import React from "react";
import "./style.scss";
import TedGanache from "../../../assets/images/ted_ganache.png";
import Gradient from "../ui/Gradient/Gradient";
import Flex from "../ui/Flex/Flex";

type HeroProps = {
  introduction: string;
};

const Hero = ({ introduction }: HeroProps): JSX.Element => {
  return (
    <section
      data-scroll-section
      className="section-wrapper h-100 data-section"
      id="presentation"
    >
      <Flex
        gap={0}
        justifyBetween
        alignCenter
        fullHeight
        minHeight="100vh"
        data-scroll-repeat
        data-scroll-call="#presentation"
      >
        <div data-scroll data-scroll-speed="3">
          <Flex column gap={5} justifyCenter>
            <h1 className="text-title-1 font-weight-3">
              THEO HOUYOUX,
              <br />
              <Gradient>UI & UX</Gradient>
              <Gradient>designer</Gradient>
            </h1>
            <p className="text-secondary">{introduction}</p>
          </Flex>
        </div>
        <div data-scroll data-scroll-speed="1.7">
          <Flex gap={0} alignCenter justifyCenter>
            <div className="relative">
              <img src={TedGanache} alt="" />
              <div className="shape shape-1"></div>
              <div className="shape shape-2"></div>
              <div className="shape shape-3"></div>
            </div>
          </Flex>
        </div>
      </Flex>
    </section>
  );
};

export default Hero;
